import { render, staticRenderFns } from "./SubscriptionType.vue?vue&type=template&id=905e08d4&"
import script from "./SubscriptionType.vue?vue&type=script&lang=js&"
export * from "./SubscriptionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../whitelabel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports